import { Link } from "react-router";
import { t } from "ttag";

import { ActionIcon, Icon, Tooltip } from "metabase/ui";
import * as Urls from "metabase-enterprise/urls";

export const EditUserStrategySettingsButton = ({
  page,
}: {
  page: "people" | "tenants";
}) => (
  // A single <a>, not <Link><ActionIcon/></Link> — nesting a real,
  // independently-tabbable <button> inside an <a> gave this control two tab
  // stops for one action (WCAG 2.1.1, widget_tabbable_single).
  <Tooltip label={t`Edit user strategy`}>
    <ActionIcon
      component={Link}
      to={Urls.editUserStrategy(page)}
      aria-label={t`Edit user strategy`}
      size="lg"
      variant="outline"
      c="text-primary"
      bd="1px solid var(--mb-color-border-neutral)"
    >
      <Icon name="gear" />
    </ActionIcon>
  </Tooltip>
);
